"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSelectorId = exports.DEFAULT_TEXTS = void 0;
exports.DEFAULT_TEXTS = {
    shortJanuary: 'Jan',
    shortFebruary: 'Feb',
    shortMarch: 'Mar',
    shortApril: 'Apr',
    shortMay: 'May',
    shortJune: 'Jun',
    shortJuly: 'Jul',
    shortAugust: 'Aug',
    shortSeptember: 'Sep',
    shortOctober: 'Oct',
    shortNovember: 'Nov',
    shortDecember: 'Dec'
};
exports.dataSelectorId = {
    prevListYearsControl: 'prev-list-years-control',
    nextListYearsControl: 'next-list-years-control',
    monthControlPartId: 'month-control',
    yearControlPartId: 'year-control'
};
//# sourceMappingURL=constants.js.map